//暂时没用
import React from 'react';
import {goCommonPage,setlog} from '@modules/58m';
import prdApi from "@config/api";
export default (props)=>{
    function jump(urlvalue){
      if(urlvalue==="springyymain"){
        setlog("chatbot_chunyung_click_1");
      }
      if(urlvalue==="springyygame"){
        setlog("chatbot_chunyung_click_2");
      }
      goCommonPage(prdApi.jumpUrl[urlvalue])
    }
    return (
        <div className="chatpanel-item chatpanel-item-card-yy-multi">
        <div className="item-container">
          <div className="item-content-wrap">
            <div className="item-content" onClick={jump.bind(this,'springyymain')}>
              <div className="item-pic"></div>
              <div className="item-main-title">叮咚，有您的口令红包，请注意查收</div>
            </div>
            <div className="item-content" onClick={jump.bind(this,'springyygame')}>
              <div className="item-pic"></div>
              <div className="item-main-title">玩游戏拿iPhone,还能瓜分现金红包</div>
            </div>
          </div>
        </div>
      </div>
    )
}